import React from "react";
import { FormFieldWrapper, FormFieldName, FormFieldLine } from "./_.styled";

const FormField = ({ name }) => {
  return (
    <FormFieldWrapper data-auto="checklistform-field">
      <FormFieldName data-auto="checklistform-field-name">{name}</FormFieldName>
      <FormFieldLine data-auto="checklistform-field-line" />
    </FormFieldWrapper>
  );
};

FormField.displayName = "ChecklistFormField";

export default FormField;
